import { computed } from "vue";
import { useBaseCalendarConfig } from "../calendar-configs/useBaseCalendarConfig";
import { useSingleRoomConfig } from "../calendar-configs/useSingleRoomConfig";
import { useMultiRoomConfig } from "../calendar-configs/useMultiRoomConfig";

export function useCalendarConfig(
	props,
	handlers,
	queryClient,
	options = {}
) {
	const { mode = "single-room", masterData, calendarFilters } = options;

	// Get base configuration
	const baseConfig = useBaseCalendarConfig(handlers, queryClient, calendarFilters, masterData);

	// Store special functions separately from calendar options
	let currentSpecialFunctions = {};

	// Create reactive calendar options
	const calendarOptions = computed(() => {
		// Get mode-specific configuration
		let modeConfig;
		switch (mode) {
			case "single-room":
				modeConfig = useSingleRoomConfig(
					props,
					queryClient,
					masterData,
					handlers,
					calendarFilters
				);
				break;
			case "multi-room":
				modeConfig = useMultiRoomConfig(queryClient, masterData, calendarFilters, handlers);
				break;
			default:
				throw new Error(`Unknown calendar mode: ${mode}`);
		}

		// No special functions to extract anymore
		const calendarConfig = modeConfig;
		
		// Store the special functions separately
		currentSpecialFunctions = {};

		// Merge configurations (excluding special functions)
		return {
			...baseConfig,
			...calendarConfig,
		};
	});

	// Helper to get special functions for the current mode
	const getSpecialFunctions = () => {
		return currentSpecialFunctions || {};
	};

	return {
		calendarOptions,
		getSpecialFunctions,
	};
}
